import React from 'react';
import { browserHistory, Router } from 'react-router';
import routes from '../routes';

export default () => {
    return <Router history={ browserHistory } routes={ routes }/>
};



// WEBPACK FOOTER //
// ./src/view/RouterView.js